<template>
    <div style="text-align: center; margin-top: 20px;">
        <h1>Password Reset</h1>
        <p>This link needs to be opened with the same device where the app is installed.</p>
    </div>
</template>
  
<script>
export default {
    mounted() {
        this.removeAllAttributesFromURL();
    },
    methods: {
        removeAllAttributesFromURL() {
            if (window.location.hash) {
                // Remove everything after '#' in the URL
                window.history.replaceState({}, document.title, window.location.href.split('#')[0]);
            }
        }
    }
};
</script>
  